import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  page: 1,
  limit: 10,
  totalPage: 2,
  pageInfo: {},

  list: [],

  bizRequestInfo: {
    bizRequestNo: '',
    storeNo: '',
    depositor: '',
    requestAmount: 0,
    acceptAmount: 0,
    status: '',
    requestDate: '', // 2023-10-06T12:27:11
    checkedDate: '', // 2023-10-06T12:27:11
    completedDate: '', // 2023-10-06T12:27:11
    cancelledDate: '', // 2023-10-06T12:27:11
    cancelledReason: '', // NOT_MATCHED
    storeName: '',
    chargedAmount: 0
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
